// Closed enum of DM role names. Mirrors the C# `DmRoleNames` constants in
//   GE.API.RetailPricing.DealManagement/Models/DmUserRole.cs
// and the CHECK constraint in scripts/dm-user-role-schema.sql.
//
// Keep these three locations in sync.
export const DM_ROLES = {
  Admin: "DM_ADMIN",
  ItAdmin: "DM_IT_ADMIN",
  ApplicationAccess: "DM_APPLICATION_ACCESS",
  Auditor: "DM_AUDITOR",
  DealOwner: "DM_DEAL_OWNER",
  DaymonUser: "DM_DAYMON_USER",
  InternalCreator: "DM_INTERNAL_CREATOR",
  InternalSubmitter: "DM_INTERNAL_SUBMITTER",
  InternalReviewer: "DM_INTERNAL_REVIEWER",
  InternalApprover: "DM_INTERNAL_APPROVER",
  ExternalViewer: "DM_EXTERNAL_VIEWER",
  ExternalCreator: "DM_EXTERNAL_CREATOR",
  ExternalSubmitter: "DM_EXTERNAL_SUBMITTER",
} as const;

export type DmRole = (typeof DM_ROLES)[keyof typeof DM_ROLES];

/**
 * Identity + role payload returned by GET /api/dealmanagement/users/me.
 * Mirrors the shape produced by CurrentUserController.Me.
 */
export interface CurrentUser {
  qualifiedUserId: string; // "GiantEagle\\1179482"
  userId: string;          // bare username "1179482"
  domainName: string;      // "GiantEagle"
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  roles: string[];

  isInternalUser: boolean;
  isExternalUser: boolean;
  isAdmin: boolean;
  isITAdmin: boolean;
  isApplicationUser: boolean;
  isAuditor: boolean;
  isDealOwner: boolean;
  isDaymonUser: boolean;
  isInternalApprover: boolean;
  isInternalCreator: boolean;
  isInternalReviewer: boolean;
  isInternalSubmitter: boolean;
  isExternalCreator: boolean;
  isExternalSubmitter: boolean;
  isExternalViewer: boolean;
}
